import React from 'react';

const SubmitButton = ({ isSubmitting, onSubmit, disabled, label = 'Submit Player Stats ->' }) => {
  return (
    <div className="submit-section">
      <button
        type="button"
        onClick={onSubmit}
        disabled={disabled || isSubmitting}
        className="submit-btn"
      >
        {isSubmitting ? 'Submitting...' : label}
      </button>
    </div>
  );
};

export default SubmitButton;

